import React from 'react';
import { WarningCircle } from '@phosphor-icons/react';
import { useAuth } from '../context/AuthContext';
import telegramService from '../services/telegram';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-gray-600">Загрузка...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated && !telegramService.getTelegramUser()?.id) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-6">
        <div className="bg-white rounded-xl p-8 max-w-md text-center">
          <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <WarningCircle size={24} className="text-yellow-600" />
          </div>
          <h2 className="text-xl font-bold text-text mb-2">
            Требуется авторизация
          </h2>
          <p className="text-gray-600 mb-6">
            Пожалуйста, откройте приложение в Telegram для доступа к этой странице
          </p>
          <div className="text-sm text-gray-500">
            <p>Это приложение работает только внутри Telegram</p>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
